import { OrganizationResponseDto } from "models/scriptSure";

export const mockGetOrganization = (): OrganizationResponseDto => {
  return {
    tenantId: 697190,
    scriptSurePracticeId: 2045,
    systemEmail: "scriptsure-staging+1232@curantissolutions.com",
    timezone: "America/Chicago",
    isActive: true,
    createdDatetime: "2024-08-16T13:58:02.545Z",
    updatedDatetime: "2024-08-20T13:19:17.893Z",
    createdBy: 0,
    updatedBy: 0,
    appId: 10147,
    appBaseUrl: "",
  };
};



// WEBPACK FOOTER //
// ./src/providers/order-data-service/mock-organization.ts